exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".local-video-wrapper[data-v-72352f6e]{width:100%}.local-video-wrapper .bottom-left[data-v-72352f6e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:30px;padding:5px 10px;background:rgba(255,255,255,.6)}.local-video-wrapper .bottom-left .head[data-v-72352f6e]{margin-right:10px}.local-video-wrapper .bottom-left .name[data-v-72352f6e]{color:#2e5aff}.focused-container[data-v-72352f6e]{border:2px solid #f56c6c}", ""]);

// exports
